import { pipe } from 'fp-ts/lib/function';
import { Alpr, VehicleInfo } from './types';
import { fromNullable, match, getOrElse } from 'fp-ts/lib/Option';
import { isEmpty } from 'fp-ts/lib/string';
import { reduce } from 'fp-ts/lib/Array';
import { lookup } from 'fp-ts/lib/Record';

export const isVehicleNameEmpty = (alprName?: string) =>
  !alprName || isEmpty(alprName as string);

export const emissionClassMap = (
  emissionClasses: { label: string; value: string }[]
) =>
  pipe(
    emissionClasses,
    reduce({}, (acc, { value }) => ({ ...acc, [value]: value }))
  );

export const vehicleInfoPrefill = (
  data: VehicleInfo | undefined,
  successFn: (mappedData: Partial<Alpr>) => void,
  errorFn: () => void,
  emissionClasses: { label: string; value: string }[]
) =>
  pipe(
    data,
    fromNullable,
    match(
      () => errorFn(),
      (data) =>
        successFn({
          ...data,
          weightClass: (!!data?.isHGV).toString(),
          hybrid: data.isHybrid.toString(),
          fuelType: data.fuelTypeId.toString(),
          emissionClass: pipe(
            emissionClasses,
            emissionClassMap,
            lookup(data?.euroEmissionNorm as string),
            getOrElse(() => undefined)
          ),
        } as Partial<Alpr>)
    )
  );
